/**
 * Formatadores de exibição. A API sempre trabalha com centavos (inteiros)
 * e datas ISO 8601 — aqui convertemos para o formato brasileiro.
 */

const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

/** 1500 → "R$ 15,00" */
export function formatCurrency(cents: number): string {
  return currencyFormatter.format(cents / 100);
}

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** "2026-08-08T21:00:00.000Z" → "08/08/2026 18:00" (fuso do navegador) */
export function formatDate(isoDate: string): string {
  return dateFormatter.format(new Date(isoDate));
}
